import { IsUUID } from 'class-validator';

export class OrderGetByUuidRequest {
    @IsUUID()
    public orderUuid: string;

    constructor(data?: Partial<OrderGetByUuidRequest>) {
        this.orderUuid = data?.orderUuid;
    }
}
